<div class="shadow-sm" [ngClass]="{
    'dark text-white-dark': store.semidark && store.menu === 'horizontal'
  }">
  <div class="relative flex w-full items-center bg-white px-5 py-2.5 dark:bg-[#0e1726]">
    <div class="horizontal-logo flex items-center justify-between lg:hidden ltr:mr-2 rtl:ml-2">
      <a routerLink="/" class="main-logo flex shrink-0 items-center">
        <img class="inline w-8 ltr:-ml-1 rtl:-mr-1"     src="/assets/images/p2p-images/logo/logo.png" alt="" />
        <span
          class="hidden align-middle text-2xl font-bold transition-all duration-300 dark:text-white-light lg:inline ltr:ml-1.5 rtl:mr-1.5">
          Source<span class="text-[#068CFE]">by</span>
        </span>
      </a>

      <a href="javascript:;"
        class="collapse-icon flex flex-none rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-primary dark:bg-dark/40 dark:text-[#d0d2d6] dark:hover:bg-dark/60 dark:hover:text-primary lg:hidden ltr:ml-2 rtl:mr-2"
        (click)="storeData.dispatch({ type: 'toggleSidebar' })">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 7L4 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          <path opacity="0.5" d="M20 12L4 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          <path d="M20 17L4 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
        </svg>
      </a>
    </div>

    <!-- Back Button and Page Title (shown for detail pages) -->
    @if ((headerConfig$ | async)?.showBackButton && store?.menu !==
    'horizontal') {
    <div class="relative z-[100009] flex flex-1 items-center gap-2">
      <h2 class="px-1 text-[16px] font-semibold text-[#0E121B] dark:text-white">
        {{ (headerConfig$ | async)?.pageTitle }}
      </h2>
    </div>
    } @if ((headerConfig$ | async)?.showSearch) {
    <div
      class="flex items-center space-x-1.5 dark:text-[#d0d2d6] sm:flex-1 lg:space-x-2 ltr:ml-auto ltr:sm:ml-0 rtl:mr-auto rtl:space-x-reverse sm:rtl:mr-0">
      <!-- search bar -->
    </div>
    }

    <!-- Right side elements (always visible) -->
    <div class="flex items-center gap-2 ltr:ml-auto rtl:mr-auto">
      <!-- theme selector -->
      <div>
        @if (store.theme === 'light') {
        <a href="javascript:;"
          class="flex items-center rounded-lg border border-gray-200 p-2 text-primary dark:border-white/10 dark:bg-dark/40 dark:hover:bg-dark/60"
          (click)="storeData.dispatch({ type: 'toggleTheme', payload: 'dark' })">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="5" stroke="currentColor" stroke-width="1.5" />
            <path d="M12 2V4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            <path d="M12 20V22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            <path d="M4 12L2 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            <path d="M22 12L20 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            <path opacity="0.5" d="M19.7778 4.22266L17.5558 6.25424" stroke="currentColor" stroke-width="1.5"
              stroke-linecap="round" />
            <path opacity="0.5" d="M4.22217 4.22266L6.44418 6.25424" stroke="currentColor" stroke-width="1.5"
              stroke-linecap="round" />
            <path opacity="0.5" d="M6.44434 17.5557L4.22211 19.7779" stroke="currentColor" stroke-width="1.5"
              stroke-linecap="round" />
            <path opacity="0.5" d="M19.7778 19.7773L17.5558 17.5551" stroke="currentColor" stroke-width="1.5"
              stroke-linecap="round" />
          </svg>
        </a>
        } @if (store.theme === 'dark') {
        <a href="javascript:;"
          class="flex items-center rounded-lg border border-gray-200 p-2 hover:bg-white-light/90 text-primary dark:border-white/10 dark:bg-dark/40 dark:hover:bg-dark/60"
          (click)="
            storeData.dispatch({ type: 'toggleTheme', payload: 'light' })
          ">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21.0672 11.8568L20.4253 11.469L21.0672 11.8568ZM12.1432 2.93276L11.7553 2.29085V2.29085L12.1432 2.93276ZM21.25 12C21.25 17.1086 17.1086 21.25 12 21.25V22.75C17.9371 22.75 22.75 17.9371 22.75 12H21.25ZM12 21.25C6.89137 21.25 2.75 17.1086 2.75 12H1.25C1.25 17.9371 6.06294 22.75 12 22.75V21.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75V1.25C6.06294 1.25 1.25 6.06294 1.25 12H2.75ZM15.5 14.25C12.3244 14.25 9.75 11.6756 9.75 8.5H8.25C8.25 12.5041 11.4959 15.75 15.5 15.75V14.25ZM20.4253 11.469C19.4172 13.1373 17.5882 14.25 15.5 14.25V15.75C18.1349 15.75 20.4407 14.3439 21.7092 12.2447L20.4253 11.469ZM9.75 8.5C9.75 6.41182 10.8627 4.5828 12.531 3.57467L11.7553 2.29085C9.65609 3.5593 8.25 5.86509 8.25 8.5H9.75ZM12 2.75C11.9115 2.75 11.8077 2.71008 11.7324 2.63168C11.6686 2.56527 11.6538 2.50244 11.6503 2.47703C11.6461 2.44587 11.6482 2.35557 11.7553 2.29085L12.531 3.57467C13.0342 3.27065 13.196 2.71398 13.1368 2.27627C13.0754 1.82126 12.7166 1.25 12 1.25V2.75ZM21.7092 12.2447C21.6444 12.3518 21.5541 12.3539 21.523 12.3497C21.4976 12.3462 21.4347 12.3314 21.3683 12.2676C21.2899 12.1923 21.25 12.0885 21.25 12H22.75C22.75 11.2834 22.1787 10.9246 21.7237 10.8632C21.286 10.804 20.7293 10.9658 20.4253 11.469L21.7092 12.2447Z"
              fill="currentColor" />
          </svg>
        </a>
        }
       
      </div>
     
      <!-- chats -->
      @if ((headerConfig$ | async)?.showActivities) {
      <button routerLink="/chat"
        class="relative block rounded-lg border border-gray-200 p-2 hover:bg-white-light/90 text-primary dark:border-white/10 dark:bg-dark/40 dark:hover:bg-dark/60">
        <icon-chat class="h-4 w-4"></icon-chat>
        @if (totalChatUnreadCount > 0) {
        <span class="absolute top-0 flex h-3 w-3 ltr:right-[0px] rtl:left-[0px]">
          <span
            class="absolute -top-[3px] inline-flex h-full w-full animate-ping rounded-full bg-success/50 opacity-75 ltr:-left-[3px] rtl:-right-[3px]"></span>
          <span class="relative inline-flex h-[6px] w-[6px] rounded-full bg-success"></span>
        </span>
        }
      </button>
      }
      <!-- notifications -->
      <!-- ========== ORIGINAL PERMISSION CHECK (COMMENTED OUT) ========== -->
      <!-- Original: if (permissionService.getNoPermission()) -->
      <div class="dropdown shrink-0">
        <div hlMenu>
          <button type="button" hlMenuButton (click)="getNotifications()"
            class="relative block rounded-lg border border-gray-200 p-2 hover:bg-white-light/90 hover:text-primary dark:border-white/10 dark:bg-dark/40 dark:hover:bg-dark/60">
            <icon-notification class="h-4 w-4"></icon-notification>

            @if (unreadNotificationCount > 0) {
            <span class="absolute top-0 flex h-3 w-3 ltr:right-0 rtl:left-0">
              <span
                class="absolute -top-[3px] inline-flex h-full w-full animate-ping rounded-full bg-success/50 opacity-75 ltr:-left-[3px] rtl:-right-[3px]"></span>
              <span class="relative inline-flex h-[6px] w-[6px] rounded-full bg-success"></span>
            </span>
            }
          </button>
          <ul *hlMenuItems @toggleAnimation
            class="custom-shadow relative right-[-123px] top-10 !z-50 w-[300px] divide-y rounded-lg !py-0 text-dark dark:divide-white/10 dark:text-white-dark sm:w-[350px] ltr:right-[-123px] rtl:right-[-123px] md:rtl:-left-2 md:rtl:-right-2">
            <li>
              <div
                class="absolute left-0 top-0 flex w-full items-center justify-between bg-white px-4 py-2 font-semibold dark:bg-[#0e1726]">
                <div class="flex items-center gap-2">
                  <icon-notification1 class="h-4 w-4"></icon-notification1>
                  <h4 class="text-[16px] font-semibold text-primary">
                    Notifications
                  </h4>
                </div>
                <div class="flex items-center gap-1">
                  <button type="button"
                    class="rounded bg-[#F5F7FA] px-2 py-1 text-xs hover:bg-[#c3d9fa] dark:bg-[#1E293B]" [ngClass]="{
                      'bg-[#c3d9fa] text-black dark:!bg-[#6ba5fc3a] dark:text-white':
                        selectedNotifTab() === 'all'
                    }" (click)="notificationsTab('all')">
                    All
                  </button>
                  <button type="button"
                    class="rounded bg-[#F5F7FA] px-2 py-1 text-xs hover:bg-[#c3d9fa] dark:bg-[#1E293B]" [ngClass]="{
                      'bg-[#c3d9fa] text-black dark:!bg-[#6ba5fc3a] dark:text-white':
                        selectedNotifTab() === 'read'
                    }" (click)="notificationsTab('read')">
                    Read
                  </button>
                  <button type="button"
                    class="rounded bg-[#F5F7FA] px-2 py-1 text-xs hover:bg-[#c3d9fa] dark:bg-[#1E293B]" [ngClass]="{
                      'bg-[#c3d9fa] text-black dark:!bg-[#6ba5fc3a] dark:text-white':
                        selectedNotifTab() === 'unread'
                    }" (click)="notificationsTab('unread')">
                    Unread
                  </button>
                </div>
              </div>
            </li>
            @if (filteredNotifications.length) {
            <li class="mt-10 h-[350px] overflow-y-auto">
              @for (n of filteredNotifications; track n) {
              <div class="border-b border-[#E1E4EA] text-primary dark:border-[#1b2e4b]">
                <div class="group flex items-center gap-3 px-4 py-3 hover:bg-gray-50 dark:bg-[#0e1726]">
                  <div class="flex-none">
                    <div
                      class="grid h-8 w-8 place-content-center rounded-full border border-[#E1E4EA] bg-[#F5F7FA] text-secondary dark:border-[#1b2e4b] dark:bg-[#1E293B]">
                      <ng-container *ngComponentOutlet="n.iconCmp"></ng-container>
                    </div>
                  </div>
                  <div class="flex-1 cursor-pointer" (click)="handleNotificationClick(n)">
                    <div class="flex-1">
                      <div class="flex items-start justify-between">
                        <h6 class="font-semibold text-[#0E121B] dark:text-white">
                          {{ compactNotificationHeading(n) }}
                        </h6>
                        <span class="mt-1 h-2.5 w-2.5 rounded-full"
                          [ngClass]="n.read ? 'bg-success' : 'bg-red-600'"></span>
                      </div>
                      @if (n?.message) {
                      <div class="text-xs text-[#64748B] dark:text-white/60">
                        {{ notificationPreview(n?.message) }}
                      </div>
                      }
                      @if (n?.title) {
                      <div class="text-xs font-medium text-gray-600 dark:text-white/60">
                        {{ n?.title }}
                      </div>
                      }
                      @if (n?.created_at) {
                      <div class="text-xs text-[#3c3d3d] dark:text-white/60">
                        {{ notificationTimeLabel(n) }}
                      </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
              }
            </li>
            } @if (filteredNotifications.length) {
            <li>
              <div class="flex justify-center px-4 py-2">
                <app-button-fill (click)="getAllNotification()" title="Read All Notifications" type="button"
                  routerLink="/notification-master" *hlMenuItem="let menuItem"></app-button-fill>
              </div>
            </li>
            } @if (!filteredNotifications.length) {
            <li>
              <div class="!grid min-h-[200px] place-content-center text-lg hover:!bg-transparent">
                <div class="mx-auto mb-4 rounded-full text-primary ring-4 ring-primary/30">
                  <svg width="40" height="40" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.5"
                      d="M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10Z"
                      fill="currentColor" />
                    <path
                      d="M10 4.25C10.4142 4.25 10.75 4.58579 10.75 5V11C10.75 11.4142 10.4142 11.75 10 11.75C9.58579 11.75 9.25 11.4142 9.25 11V5C9.25 4.58579 9.58579 4.25 10 4.25Z"
                      fill="currentColor" />
                    <path
                      d="M10 15C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15Z"
                      fill="currentColor" />
                  </svg>
                </div>
                No data available.
              </div>
            </li>
            }
          </ul>
        </div>
      </div>

      <!-- country dropdown -->
      <div class="dropdown hidden ltr:ml-auto rtl:mr-auto">
        <div hlMenu>
          <a hlMenuButton href="javascript:;"
            class="flex items-center gap-x-2 rounded-lg border border-gray-200 px-2 py-1.5 align-middle hover:shadow-inner dark:border-white/10">
            <span class="border-0 border-[#d1d2d3] py-0.5 pr-0.5 dark:border-[#1b2e4b] md:border-r md:pr-2 lg:py-0">
              <icon-india class="h-4 w-4"></icon-india>
            </span>
            <span class="hidden lg:block text-[12px] font-medium text-primary">India</span>
            <span class="hidden pl-0 lg:block lg:pl-2">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="ng-star-inserted inline-block ltr:ml-1 rtl:mr-1">
                <path d="M19 9L12 15L5 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round"></path>
              </svg>
            </span>
          </a>
          <ul *hlMenuItems @toggleAnimation class="top-9 w-[150px] text-xs 2xl:text-[13px] ltr:right-0 rtl:left-0">
            <li>
              <a class="flex items-center gap-x-2" *hlMenuItem="let menuItem">
                <span class="border-r border-[#d1d2d3] pr-2 dark:border-[#1b2e4b]">
                  <icon-germany></icon-germany>
                </span>
                Germany
              </a>
            </li>
            <li>
              <a class="flex items-center gap-x-2" *hlMenuItem="let menuItem">
                <span class="border-r border-[#d1d2d3] pr-2 dark:border-[#1b2e4b]">
                  <icon-usa></icon-usa>
                </span>
                United States
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- currency dropdown -->
      <div class="dropdown ltr:ml-auto rtl:mr-auto">
        <div hlMenu>
          <a hlMenuButton href="javascript:;"
            class="flex items-center gap-x-2 rounded-lg border border-gray-200 px-2 py-1.5 align-middle hover:shadow-inner dark:border-white/10">
            @if (showCurrencyPlaceholder()) {
              <span class="border-0 border-[#d1d2d3] pr-0.5 dark:border-[#1b2e4b] md:border-r md:pr-2 lg:py-0">
                <span class="inline-flex h-3 w-3 items-center justify-center text-[12px] leading-none">{{ tenantCurrencySymbol }}</span>
              </span>
              <span class="hidden text-[12px] font-medium lg:block">{{ tenantCurrency }}</span>
            } @else {
              <span class="border-0 border-[#d1d2d3] py-1 pr-0.5 dark:border-[#1b2e4b] md:border-r md:pr-2 lg:py-0">
                <span class="inline-flex h-3 w-3 items-center justify-center text-[12px] leading-none">{{ currencySymbol() }}</span>
              </span>
              <span class="hidden text-[12px] font-medium lg:block">{{ currencyCode() }}</span>
  
            }
            <span class="hidden pl-0 lg:block lg:pl-2">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="ng-star-inserted inline-block ltr:ml-1 rtl:mr-1">
                <path d="M19 9L12 15L5 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round"></path>
              </svg>
            </span>
          </a>
          <ul *hlMenuItems @toggleAnimation class="top-9 min-w-[120px] text-xs 2xl:text-[13px] ltr:right-0 rtl:left-0 z-50">
            <li>
              <a class="flex cursor-pointer items-center gap-x-2  border-b border-[#E1E4EA] px-2 py-1.5"
                *hlMenuItem="let menuItem" (click)="clearCurrencySelection()">
                <span class="pr-0">{{tenantCurrencySymbol}}</span>
                <span class="border-l border-[#d1d2d3] pl-2 dark:border-[#1b2e4b]">{{tenantCurrency}}</span>
              </a>
            </li>
            @for (currency of currencies; track currency.code) {
            <li>
              <a class="flex cursor-pointer items-center gap-x-2" *hlMenuItem="let menuItem" (click)="changeCurrency(currency.symbol, currency.code)"><span
                  class="border-r border-[#d1d2d3] pr-2 dark:border-[#1b2e4b]">{{ currency.symbol }}
                    </span>{{ currency.code }}</a>
            </li>
            }
          </ul>
        </div>
      </div>
      <!-- quick actions -->
      <div class="dropdown ltr:ml-auto rtl:mr-auto">
        <div hlMenu>
          <a hlMenuButton href="javascript:;"
            class="flex items-center gap-x-2 rounded-lg border border-gray-200 px-2 py-1.5 align-middle hover:shadow-inner dark:border-white/10">
            <span class="py-1 lg:py-0">
              <icon-plus></icon-plus>
            </span>
            <span class="hidden text-[12px] font-medium lg:block text-primary">Quick Actions</span>
          </a>
          <ul *hlMenuItems @toggleAnimation class="top-9 w-[150px] text-xs 2xl:text-[13px] ltr:right-0 rtl:left-0 z-50">
            <li>
              <a [routerLink]="'/event-master/add-edit-event/general-details'" [queryParams]="{ eventType: 'RFQ' }"
                class="flex items-center gap-x-2" *hlMenuItem="let menuItem"><icon-create-rfq></icon-create-rfq>Create
                RFQ</a>
            </li>
            @if (subModuleAccessService.hasSubModuleAccess('event', 'rfi')) {
            <li>
              <a [routerLink]="'/event-master/add-edit-event/general-details'" [queryParams]="{ eventType: 'RFI' }"
                class="flex items-center gap-x-2" *hlMenuItem="let menuItem"><icon-create-rfi></icon-create-rfi>Create
                RFI</a>
            </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>

  @if (store.menu === 'horizontal') {
  <ul
    class="horizontal-menu hidden w-full border-t border-[#ebedf2] bg-white px-4 py-1.5 font-semibold text-primary dark:border-[#191e3a] dark:bg-[#0e1726] lg:flex lg:items-center lg:space-x-1.5 xl:space-x-2 rtl:space-x-reverse">
    <!-- Dashboard -->
    @if (moduleAccessService.hasModuleAccess('dashboard')) {
    <li class="menu nav-item relative">
      <a routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }"
        class="nav-link">
        <div class="flex items-center">
          <icon-menu-dashboard class="shrink-0"></icon-menu-dashboard>
          <span class="px-2">Dashboard</span>
        </div>
      </a>
    </li>
    }
    <!-- Explore Vendors -->
    @if (moduleAccessService.hasModuleAccess('explore-vendor')) {
    <li class="menu nav-item relative">
      <a routerLink="/explore-vendor-master/explore-vendor" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }"
        class="nav-link">
        <div class="flex items-center text-secondary">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path id="member-search"
              d="M7.513,10A5,5,0,1,0,2.5,5,5.009,5.009,0,0,0,7.513,10Zm0-8.333A3.333,3.333,0,1,1,4.174,5,3.34,3.34,0,0,1,7.513,1.667ZM20,18.788l-3.165-3.16a4.188,4.188,0,1,0-1.18,1.178l3.165,3.16Zm-6.644-2.954a2.5,2.5,0,1,1,2.5-2.5A2.505,2.505,0,0,1,13.356,15.833Zm-5.6-4.167a5.816,5.816,0,0,0-.245,1.667H4.174a2.505,2.505,0,0,0-2.5,2.5V20H0V15.833a4.175,4.175,0,0,1,4.174-4.167Z"
              fill="currentColor" />
          </svg>
          <span class="px-2">Explore Vendors</span>
        </div>
      </a>
    </li>
    }
    <!-- Event -->
    @if (moduleAccessService.hasModuleAccess('event')) {
    <li class="menu nav-item relative">
      <a routerLink="/event-master/event-list" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }"
        class="nav-link">
        <div class="flex items-center">
          <icon-event class="shrink-0"></icon-event>
          <span class="px-2">Event</span>
        </div>
      </a>
    </li>
    }
    <!-- Purchase Request -->
    @if (permissionService.hasModuleOrSubModuleAccess('purchase-order','purchase-order-list')) {
    <li class="menu nav-item relative">
      <a routerLink="/purchase-order-master/purchase-order-list" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }" class="nav-link">
        <div class="flex items-center">
          <icon-gen-po class="h-4 w-4"></icon-gen-po>
          <span class="px-2">Purchase Order</span>
        </div>
      </a>
    </li>
    }
    <!-- Admin Center -->
    @if (showAdminCenter()) {
    <li class="menu nav-item relative">
      <a href="javascript:;" class="nav-link">
        <div class="flex items-center">
          <icon-apps class="shrink-0"></icon-apps>
          <span class="px-2">Admin Center</span>
        </div>
        <div class="right_arrow">
          <svg class="h-4 w-4 rotate-90" width="16" height="16" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
      </a>
      <ul class="sub-menu">
        @if (moduleAccessService.hasModuleAccess('contract')) {
        <li>
          <a routerLink="/admin-center/contract-management" routerLinkActive="active"><icon-contract-signature
              class="h-4 w-4"></icon-contract-signature>Contract</a>
        </li>
        }
        @if (permissionService.hasModuleOrSubModuleAccess('contract', 'contract-template')) {
        <li>
          <a routerLink="/admin-center/contract-template-list" routerLinkActive="active">
            <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" width="16.674" height="20" viewBox="0 0 16.674 20">
              <path id="cont-template"
                d="M16.965,4.62l-2.9-2.9A5.8,5.8,0,0,0,9.937.01H6.168A4.157,4.157,0,0,0,2,4.17V15.842A4.17,4.17,0,0,0,6.168,20.01h8.337a4.17,4.17,0,0,0,4.168-4.168V8.747A5.8,5.8,0,0,0,16.965,4.62ZM15.789,5.8a4.237,4.237,0,0,1,.675.875H12.846a.836.836,0,0,1-.834-.834V2.219a4.237,4.237,0,0,1,.875.675Zm1.217,10.046a2.508,2.508,0,0,1-2.5,2.5H6.168a2.508,2.508,0,0,1-2.5-2.5V4.17a2.508,2.508,0,0,1,2.5-2.5h3.76a3.348,3.348,0,0,1,.409.017V5.837a2.508,2.508,0,0,0,2.5,2.5H16.99a3.28,3.28,0,0,1,.017.409Zm-3.752-5.836H7.419A2.085,2.085,0,0,0,5.335,12.09v2.5a2.085,2.085,0,0,0,2.084,2.084h5.836a2.085,2.085,0,0,0,2.084-2.084v-2.5A2.085,2.085,0,0,0,13.255,10.006Zm.417,4.585a.413.413,0,0,1-.417.417H7.419A.413.413,0,0,1,7,14.591v-2.5a.413.413,0,0,1,.417-.417h5.836a.413.413,0,0,1,.417.417ZM5.335,7.5a.836.836,0,0,1,.834-.834H7.836a.834.834,0,0,1,0,1.667H6.168A.836.836,0,0,1,5.335,7.5Z"
                transform="translate(-2 -0.01)" fill="currentColor" />
            </svg>Contract Templates</a>
        </li>
        }
        @if (permissionService.hasModuleOrSubModuleAccess('event', 'template-builder')) {
        <li>
          <a routerLink="/admin-center/template-builder" routerLinkActive="active">
            <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" width="16" height="16.001" viewBox="0 0 16 16.001">
              <path id="temp-build"
                d="M12.542,6.667a.667.667,0,0,0,.646-.832A4.67,4.67,0,0,0,11.966,3.69L9.643,1.367A4.636,4.636,0,0,0,6.343,0H3.333A3.337,3.337,0,0,0,0,3.333v9.333A3.337,3.337,0,0,0,3.333,16h2a.667.667,0,1,0,0-1.333h-2a2,2,0,0,1-2-2V3.333a2,2,0,0,1,2-2h3.01c.109,0,.217.005.323.015V4.667a2,2,0,0,0,2,2ZM8,4.667V1.773a3.358,3.358,0,0,1,.7.537l2.323,2.323a3.363,3.363,0,0,1,.535.7H8.667A.668.668,0,0,1,8,4.667Zm7.415,3.253a2.047,2.047,0,0,0-2.829,0L8.115,12.391a2.651,2.651,0,0,0-.781,1.886v1.057A.667.667,0,0,0,8,16H9.057a2.649,2.649,0,0,0,1.885-.781l4.471-4.471a2,2,0,0,0,0-2.829ZM14.471,9.8,10,14.276a1.322,1.322,0,0,1-.943.391H8.666v-.391a1.324,1.324,0,0,1,.391-.943l4.472-4.471a.682.682,0,0,1,.943,0,.666.666,0,0,1,0,.943Z"
                fill="currentColor" />
            </svg>
            Template Builder</a>
        </li>
        }
        @if (permissionService.hasModuleOrSubModuleAccess('event', 'form-builder')) {
        <li>
          <a routerLink="/admin-center/form-builder" routerLinkActive="active">
            <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
              <path id="form-build"
                d="M14,0H2A2,2,0,0,0,0,2V14a2,2,0,0,0,2,2H14a2,2,0,0,0,2-2V2A2,2,0,0,0,14,0ZM2,14V2H14V14ZM4,4h8V5H4Zm0,2h8V7H4Zm0,2h6V9H4Zm0,2h4V11H4Z"
                fill="currentColor" />
            </svg>
            Form Builder</a>
        </li>
        }
        @if (permissionService.hasModuleOrSubModuleAccess('purchase-order', 'purchase-order-list')) {
        <li>
          <a routerLink="/admin-center/po-builder" routerLinkActive="active">
            <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
              <path
                d="M12.542,6.667a.667.667,0,0,0,.646-.832A4.67,4.67,0,0,0,11.966,3.69L9.643,1.367A4.636,4.636,0,0,0,6.343,0H3.333A3.337,3.337,0,0,0,0,3.333v9.333A3.337,3.337,0,0,0,3.333,16h2a.667.667,0,1,0,0-1.333h-2a2,2,0,0,1-2-2V3.333a2,2,0,0,1,2-2h3.01c.109,0,.217.005.323.015V4.667a2,2,0,0,0,2,2ZM8,4.667V1.773a3.358,3.358,0,0,1,.7.537l2.323,2.323a3.363,3.363,0,0,1,.535.7H8.667A.668.668,0,0,1,8,4.667Zm7.415,3.253a2.047,2.047,0,0,0-2.829,0L8.115,12.391a2.651,2.651,0,0,0-.781,1.886v1.057A.667.667,0,0,0,8,16H9.057a2.649,2.649,0,0,0,1.885-.781l4.471-4.471a2,2,0,0,0,0-2.829ZM14.471,9.8,10,14.276a1.322,1.322,0,0,1-.943.391H8.666v-.391a1.324,1.324,0,0,1,.391-.943l4.472-4.471a.682.682,0,0,1,.943,0,.666.666,0,0,1,0,.943Z"
                fill="currentColor" />
            </svg>
            PO Builder</a>
        </li>
        }
        @if (permissionService.hasModuleOrSubModuleAccess('contract', 'clause')) {
        <li>
          <a routerLink="/admin-center/clauses" routerLinkActive="active">
            <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
              <path
                d="M2,0H0V16H16V0H2ZM14,14H2V2H14ZM4,4H12V5H4Zm0,2H12V7H4Zm0,2H10V9H4Zm0,2H8V11H4Z"
                fill="currentColor" />
            </svg>
            Clauses</a>
        </li>
        }
      </ul>
    </li>
    }
    <!-- } -->
    <!-- Profile Dropdown — end of horizontal nav row -->
    <li class="menu nav-item relative shrink-0 ltr:!ml-auto rtl:!mr-auto">
      <div class="dropdown relative shrink-0">
        <div hlMenu class="!block">
          <button type="button" hlMenuButton class="group relative flex items-center justify-center">
            @if((profile_picture && profile_picture.trim() !== '') ||
            (profile_picture === '' && userData?.profile_picture)) {
            <img class="h-8 w-8 rounded-full object-cover" [src]="profileImageUrl" alt=""
              (error)="authService.onImageError($event, userData)" />
            } @else {
            <div
              class="relative flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-purple-600 text-white shadow-lg transition-transform duration-300">
              <span
                class="inline-flex h-8 w-8 items-center justify-center rounded-full text-xs font-semibold text-white">
                {{ imageService.getInitials(userData?.name) }}
              </span>
            </div>
            }
          </button>
          <ul *hlMenuItems @toggleAnimation
            class="absolute right-0 top-full z-[10000009] mt-2 w-[230px] !py-0 font-semibold text-primary">
            <li>
              <div class="flex items-center px-4 py-4">
                <div class="flex-none">
                  @if((profile_picture && profile_picture.trim() !== '') ||
                  (profile_picture === '' && userData?.profile_picture)) {
                  <img class="h-10 w-10 rounded-full object-cover" [src]="profileImageUrl" alt=""
                    (error)="authService.onImageError($event, userData)" />
                  } @else {
                  <div
                    class="relative flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-purple-600 text-white shadow-lg transition-transform duration-300">
                    <span
                      class="inline-flex h-8 w-8 items-center justify-center rounded-full text-[11px] font-semibold text-white">
                      {{ imageService.getInitials(userData?.name) }}
                    </span>
                  </div>
                  }
                </div>
                <div class="truncate ltr:pl-4 rtl:pr-4">
                  <h4 class="text-base">
                    {{ profile_name || userData?.name }}
                  </h4>
                  <a class="text-black/60 hover:text-primary dark:text-dark-light/60 dark:hover:text-white"
                    href="javascript:;">{{ profile_email || userData?.email_id }}</a>
                </div>
              </div>
            </li>
            <li>
              <a routerLink="/users/profile"
                class="flex cursor-pointer items-center gap-2 border-t border-gray-200 px-4 py-2 pt-2 text-primary dark:border-white/10">
                <svg class="h-4.5 w-4.5 shrink-0" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="6" r="4" stroke="currentColor" stroke-width="1.5" />
                  <path opacity="0.5"
                    d="M20 17.5C20 19.9853 20 22 12 22C4 22 4 19.9853 4 17.5C4 15.0147 7.58172 13 12 13C16.4183 13 20 15.0147 20 17.5Z"
                    stroke="currentColor" stroke-width="1.5" />
                </svg>
                <span>View Profile</span>
              </a>
            </li>
            <!-- } -->
            <li class="border-t border-white-light dark:border-white-light/10">
              <a (click)="signOut()" class="flex cursor-pointer items-center gap-2 !py-3 px-4 text-primary">
                <svg class="h-4.5 w-4.5 shrink-0 rotate-90" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.5"
                    d="M17 9.00195C19.175 9.01406 20.3529 9.11051 21.1213 9.8789C22 10.7576 22 12.1718 22 15.0002V16.0002C22 18.8286 22 20.2429 21.1213 21.1215C20.2426 22.0002 18.8284 22.0002 16 22.0002H8C5.17157 22.0002 3.75736 22.0002 2.87868 21.1215C2 20.2429 2 18.8286 2 16.0002L2 15.0002C2 12.1718 2 10.7576 2.87868 9.87889C3.64706 9.11051 4.82497 9.01406 7 9.00195"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                  <path d="M12 15L12 2M12 2L15 5.5M12 2L9 5.5" stroke="currentColor" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>Sign Out</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </li>
  </ul>
  }
</div>

@if (viewNotificationModel()) {
<app-modal title="Notification" (close)="closeViewNotificationModal()" [showFooter]="false">
  <div class="min-w-auto modal-content w-full sm:min-w-[500px] lg:min-w-[600px]">
    <div class="relative p-4">
      <!-- Notification Type Tag -->
      <div>
        <span class="inline-block rounded-md px-3 py-1 text-xs font-semibold" [ngClass]="{
            'bg-purple-100 text-purple-800 dark:bg-[#b786fa2f] dark:text-purple-400':
              isReadableNotificationDetails()?.alert_type === 'VENDOR_KYC',
            'bg-green-100 text-green-800 dark:bg-[#008000]/10 dark:text-green-400':
              isReadableNotificationDetails()?.alert_type === 'PAYMENT',
            'bg-emerald-100 text-emerald-800 dark:text-emerald-400':
              isReadableNotificationDetails()?.alert_type === 'RFI',
            'bg-gray-100 text-gray-800 dark:bg-[#2d2d2d] dark:text-[#ffffffcc]':
              isReadableNotificationDetails()?.alert_type !== 'VENDOR_KYC' &&
              isReadableNotificationDetails()?.alert_type !== 'PAYMENT' &&
              isReadableNotificationDetails()?.alert_type !== 'RFI'
          }">
          {{ formatTitle(isReadableNotificationDetails()?.alert_type) }}
        </span>
      </div>

      <!-- Message -->
       <div class="py-2 border-b border-gray-200 dark:border-gray-700 pb-2 mb-2">
        @if(isReadableNotificationDetails()?.alert_type === 'GENERAL'){
             <p class="text-secondary text-xs" [innerHTML]="sanitizeHtml(isReadableNotificationDetails()?.message)"></p>
         }
         @else {
           <p class="text-secondary text-xs">
             {{ isReadableNotificationDetails()?.message }}
           </p>
         }
       </div>

      <!-- UPLOAD (custom totals + download link) -->
      @if (isReadableNotificationDetails()?.alert_type === 'UPLOAD') {
      <div class="space-y-2 text-xs">
        @if (isReadableNotificationDetails()?.meta_data?.type) { @if
        (isReadableNotificationDetails()?.meta_data?.type !== 'system_failure')
        {
        <div class="flex">
          <span class="font-medium text-primary">Total Processed:</span><span class="pl-1">{{
            isReadableNotificationDetails()?.meta_data?.totalCount || 0
            }}</span>
        </div>
        <div class="flex">
          <span class="font-medium text-green-700">Success:</span><span class="pl-1">{{
            isReadableNotificationDetails()?.meta_data?.successCount || 0
            }}</span>
        </div>
        <div class="flex">
          <span class="font-medium text-red-700">Failed:</span><span class="pl-1">{{
            isReadableNotificationDetails()?.meta_data?.errorCount ||
            isReadableNotificationDetails()?.meta_data?.failureCount ||
            0
            }}</span>
        </div>
        @if (isReadableNotificationDetails()?.meta_data?.errorFilePath) {
        <a [href]="isReadableNotificationDetails()?.meta_data?.errorFilePath" download
          class="mb-2 flex w-72 items-center rounded bg-blue-50 px-2 py-2 font-medium text-blue-700 dark:bg-[#2c2e35] dark:text-blue-100">
          <img src="assets/excel.png" alt="Excel" class="mr-2 h-6 w-6" />
          <span class="underline">Download
            {{
            getFileErrorModule(isReadableNotificationDetails()?.title)
            }}
            Error Excel</span>
        </a>
        } } } @else {
        <div class="flex">
          <span class="font-medium text-primary">Total Processed:</span><span class="pl-1">{{
            isReadableNotificationDetails()?.meta_data?.totalRecords || 0
            }}</span>
        </div>
        <div class="flex">
          <span class="font-medium text-green-700">Success:</span><span class="pl-1">{{
            isReadableNotificationDetails()?.meta_data?.successCount || 0
            }}</span>
        </div>
        <div class="flex">
          <span class="font-medium text-red-700">Failed:</span><span class="pl-1">{{
            isReadableNotificationDetails()?.meta_data?.errorCount ||
            isReadableNotificationDetails()?.meta_data?.failureCount ||
            0
            }}</span>
        </div>
        @if (isReadableNotificationDetails()?.meta_data?.errorFilePath) {
        <a [href]="isReadableNotificationDetails()?.meta_data?.errorFilePath" download
          class="mb-2 flex w-72 items-center rounded bg-blue-50 px-2 py-2 font-medium text-blue-700 dark:bg-[#2c2e35] dark:text-blue-100">
          <img src="assets/excel.png" alt="Excel" class="mr-2 h-6 w-6" />
          <span class="underline">Download
            {{
            getFileErrorModule(isReadableNotificationDetails()?.title)
            }}
            Error Excel</span>
        </a>
        } }
      </div>
      }

      @if (isReadableNotificationDetails()?.alert_type !== 'UPLOAD' && modalMetaRows().length) {
      <div class="space-y-2 text-xs text-primary">
        @for (row of modalMetaRows(); track row.label + row.value + $index) {
        <div class="flex gap-2">
          <span class="w-40 shrink-0 font-semibold">{{ row.label }}:</span>
          <span class="min-w-0 break-words">{{ row.value }}</span>
        </div>
        }
      </div>
      }

      <!-- Read/Unread -->
      <div
        class="mt-4 flex items-center border-t border-[#E1E4EA] pt-4 text-xs text-gray-600 dark:border-[#1b2e4b] dark:text-[#ffffffcc]">
        <span class="inline-block h-2 w-2 rounded-full" [ngClass]="
            isReadableNotificationDetails()?.is_read
              ? 'bg-[#1FC16B]'
              : 'bg-[#FB3748]'
          "></span>
        <span class="ml-1">{{
          isReadableNotificationDetails()?.is_read ? "Read" : "Unread"
          }}</span>
        <span class="pl-4">{{
          notificationTimeLabel(isReadableNotificationDetails())
          }}</span>
        <span class="pl-2">{{
          notificationTimeAgo(isReadableNotificationDetails())
          }}</span>
      </div>
    </div>
  </div>
</app-modal>
}